import { useEffect, useState } from 'react';
import getToken from '../helpers/getToken';
import axios from 'axios';
import { JsonEditor } from 'react-jsondata-editor';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { errorAlert, successAlert } from '../utils/toastifyAlerts'
import { ToastContainer } from 'react-toastify'
const backendUrl = process.env.REACT_APP_BACKEND_RESUME_URL;

const ResumeViewer = (state) => {

    const location = useLocation();
    const navigate = useNavigate();
    const { resumeId } = useParams();
    const rid = resumeId || location.state.resumeId;
    const resumeUrl = `${backendUrl}/${rid}`

    const [input, setInput] = useState('')

    //get token from localstorage
    const token = getToken();

    //get Resume using ID
    const getResume = async () => {
        try {
            const response = await axios.get(resumeUrl, {
                headers: { token: token }
            });
            successAlert(response.data.msg)
            setInput(JSON.stringify(response.data.resume));
        } catch (err) {
            errorAlert(err.response?.data?.msg || 'Failed to fetch resume');
        }
    }

    useEffect(() => {
        getResume()
        //eslint-disable-next-line
    }, [])

    const goBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="title re">
                <h3 data-test='title'>resume viewer</h3>
            </div>
            <div className='JSONEditorContainer'>
                <div className='JSONEditor'>
                    {/* Hacemos el editor de solo lectura con la prop 'view' */}
                    <JsonEditor jsonObject={input} view={true} />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <button data-test='back' className="my-3 btnSCV btnSCV-a" onClick={goBack}>Back</button>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default ResumeViewer